import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import withAuth from '../../../components/hocs/withAuth';
import styles from '../drawEdit.scss';
import PrintIcon from './PrintIcon';
import Img from '../../../components/Img';
import { createPrintConfig, getFacilities, postPrintTestPage } from '../../../actions/event-profile-actions';

function PrintSpoolerTab({ eventId }) {
    const dispatch = useDispatch();
    const { facilities } = useSelector(({ eventProfile }) => {
        const { facilities } = eventProfile;
        return { facilities };
    });

    const facilitiesList = facilities?.data || [];

    const handleAddPrintQueueKey = (code) => {
        window.open(`utr:${code}`);
    };

    const handleGenerateKeyCode = (item) => {
        const { clubLocationFacilityId, name } = item || {};

        dispatch(createPrintConfig({ eventId, clubLocationFacilityId, clubLocationFacilityName: name }));
    };

    const handlePrintTestPage = (item) => {
        const { clubLocationFacilityId, name, operationQueueId } = item || {};

        dispatch(postPrintTestPage({ eventId, clubLocationFacilityId, clubLocationFacilityName: name, operationQueueId }));
        window.open(`utr:start`);
    };

    useEffect(() => {
        if (eventId) {
            dispatch(getFacilities({ eventId }));
        }
    }, []);

    return (
        <div className={`container pb0`}>
            <div className={`${styles.printSpoolerContainer}`}>
                <div className={`${styles.printSpoolerTextContainer}`}>
                    <div className={`${styles.printSpoolerIconButton}`}>
                        1
                    </div>
                    <div className={`${styles.printSpoolerText}`}>
                        <p>
                            <strong>Download & Install the UTR Print Score App </strong> (First time Users)
                        </p>
                        <p>
                            The UTR Print Score App is a software program (print spooler) that pairs your printer with a facility enabling automatic scoresheet printing during your event.
                        </p>
                    </div>
                    <div className={`${styles.printSpoolerButtonContainer}`}>
                        <a href={'https://prodappdownloads.blob.core.windows.net/downloads/apple/print-score-app-v1.3.0.zip'} className={`btn btn-primary btn-sm text-uppercase ${styles.printSpoolerButton}`} data-testid="draw-edit.print-spooler.download-mac-link">
                            Download for Mac
                        </a>
                        <a href={'https://prodappdownloads.blob.core.windows.net/downloads/windows/print-score-app-v1.5.3.exe'} className={`${styles.printSpoolerButton} ${styles.printSpoolerButtonInverse} btn btn-primary btn-sm text-uppercase`} data-testid="draw-edit.print-spooler.download-pc-link">
                            Download for PC
                        </a>
                    </div>
                </div>
            </div>
            <div className={`${styles.printSpoolerContainer}`}>
                <div className={`${styles.printSpoolerTextContainer}`}>
                    <div className={`${styles.printSpoolerIconButton}`}>
                        2
                    </div>
                    <div>
                        <p>
                            <strong>Generate Unique Printer Key Codes & Add to Print Queue</strong>
                        </p>
                        <p>First click “Generate Key Code” and then the “Add to Print Queue” icon to ready your printer to pair with each facility.</p>
                        <br />
                        <div className={`${styles.printSpoolerTableRow}`}>
                            <div className={`${styles.printSpoolerTableCell}`}>
                                <p style={{ fontWeight: 700 }}>Facility</p>
                            </div>
                            <div className={`${styles.printSpoolerTableCell}`}>
                                <p style={{ fontWeight: 700 }}>Unique Printer Key Code</p>
                            </div>
                            <div className={`${styles.printSpoolerTableCellIcon}`}>
                                <p style={{ fontWeight: 700 }}>Add to Print Queue</p>
                            </div>
                            <div className={`${styles.printSpoolerTableCellIcon}`}>
                                <p style={{ fontWeight: 700 }}>Print Test</p>
                            </div>
                        </div>
                        {facilitiesList.map(item => {
                                const isActive = !!item.operationQueueId;

                                return (
                                    <div key={item.clubLocationFacilityId} className={`${styles.printSpoolerTableRow}`} data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}`}>
                                        <div className={`${styles.printSpoolerTableCell}`}>
                                            <p data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}.name`}>{item?.name}</p>
                                        </div>
                                        <div className={`${styles.printSpoolerTableCell}`}>
                                            {isActive ? (
                                                <p onClick={() => handleAddPrintQueueKey(item.operationQueueId)} className={`${styles.printLink}`} data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}.key-code`}>{item.operationQueueId}</p>
                                            ) : (
                                                <p onClick={() => handleGenerateKeyCode(item)} className={`${styles.printLink}`} data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}.generate-key-btn`}>Generate Key Code</p>
                                            )}
                                        </div>
                                        <div className={`${styles.printSpoolerTableCellIcon}`}>
                                            <button className={`${styles.printSpoolerTableCellInnerButton}`} disabled={!isActive} type="button" onClick={() => handleAddPrintQueueKey(item?.operationQueueId)} data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}.add-to-queue-btn`}>
                                                <PrintIcon disabled={!isActive} isActive={isActive} />
                                            </button>
                                        </div>
                                        <div className={`${styles.printSpoolerTableCellIcon}`}>
                                            <button className={`${styles.printSpoolerTableCellInnerButton}`} disabled={!isActive} type="button" onClick={() => handlePrintTestPage(item)} data-testid={`draw-edit.print-spooler.facility-${item.clubLocationFacilityId}.print-test-btn`}>
                                                <PrintIcon isActive={isActive} />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
            <div className={`${styles.printSpoolerContainer}`}>
                <div className={`${styles.printSpoolerTextContainer}`}>
                    <div className={`${styles.printSpoolerIconButton}`}>
                        3
                    </div>
                    <div className={`${styles.printSpoolerText}`}>
                        <p>
                            <strong>
                                Pair your Printer with the Facility
                            </strong>
                        </p>
                        <p>
                            After you have clicked the “Add to Print Queue” in step 2, your unique key code will be entered into the print queue in your UTR Print Score App. (see example to the right) Clicking “Submit” will pair your printer with the facility.
                        </p>
                    </div>
                    <div>
                        <Img style={{ width: '300px' }} src={'/img/printerImg.png'} />
                    </div>

                </div>
            </div>
        </div>
    );
}
PrintSpoolerTab.propTypes = {
    eventId: PropTypes.string,
};
PrintSpoolerTab.defaultProps = {
    eventId: '',
};
export default withAuth(PrintSpoolerTab);
